import React, {useState} from 'react';
import {Popover} from '@mantine/core';

import {Container, Input, OptionList, Option} from './styles';
import useDeliveryMenSelect from 'modules/delivery-men/hooks/use-delivery-men-select';
import useAssignOrder from 'modules/orders/hooks/use-assign-order';
import {ClipLoader} from 'react-spinners';
import useAccessControls from 'modules/access-controls/atoms/use-access-controls';
import useRemoveDeliveryManFromOrder from 'modules/orders/hooks/use-remove-delivery-man-from-order';
import Loading from 'shared/migration-components/loading';
import {GiFullMotorcycleHelmet} from 'react-icons/gi';
import {IoCloseCircle} from 'react-icons/io5';

interface Props {
  children: React.ReactNode;
  orderId: string;
  deliveryManId?: string;
}

const DeliveryManSelect: React.FC<Props> = ({
  children,
  orderId,
  deliveryManId,
}) => {
  const [opened, setOpened] = useState(false);
  const [searchText, setSearch] = useState('');
  const {accessControl} = useAccessControls();
  const {data = [], ...deliveryMenSelectQuery} = useDeliveryMenSelect(
    orderId,
    opened && !accessControl?.companyId,
  );
  const availableOptions = data.filter(
    (option) =>
      option.label.toLocaleLowerCase().search(searchText.toLocaleLowerCase()) >=
      0,
  );
  const {mutate, isLoading} = useAssignOrder(orderId);
  const removeDeliveryManFromOrderMutation =
    useRemoveDeliveryManFromOrder(orderId);

  return (
    <Popover
      key={orderId}
      withinPortal
      trapFocus={false}
      opened={opened}
      onClose={() => setOpened(false)}
      zIndex={1001}
      keepMounted
      styles={{dropdown: {padding: 0}}}>
      <Popover.Target>
        <div
          onClick={() => {
            if (
              accessControl?.cityId ||
              accessControl?.isFranchiseAccessControl
            )
              setOpened(true);
          }}>
          {isLoading || removeDeliveryManFromOrderMutation.isLoading ? (
            <ClipLoader color="black" size={20} />
          ) : (
            children
          )}
        </div>
      </Popover.Target>
      <Popover.Dropdown>
        <Container>
          {deliveryMenSelectQuery.isLoading && <Loading />}
          {!deliveryMenSelectQuery.isLoading && (
            <>
              <Input
                placeholder="Pesquisar"
                autoFocus
                onChange={(e) => setSearch(e.target.value)}
              />
              <OptionList>
                {availableOptions.map((option, index) => (
                  <Option
                    className="ignore"
                    {...{active: deliveryManId === option.value}}
                    key={index}
                    onClick={(e) => {
                      e.stopPropagation();
                      mutate({deliveryManId: option.value});
                      setOpened(false);
                    }}>
                    <GiFullMotorcycleHelmet />
                    {option?.label}
                  </Option>
                ))}
                {deliveryManId && (
                  <Option
                    active={false}
                    className="ignore"
                    onClick={(e) => {
                      e.stopPropagation();
                      removeDeliveryManFromOrderMutation.mutate(undefined);
                      setOpened(false);
                    }}>
                    <IoCloseCircle />
                    Remover entregador
                  </Option>
                )}
              </OptionList>
            </>
          )}
        </Container>
      </Popover.Dropdown>
    </Popover>
  );
};

export default DeliveryManSelect;
